/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_1_B2Inputs */

const en_mk_agent_1_b2 = /** @type {(inputs: Mk_Agent_1_B2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A full transcript: which tools it used, which data it read`)
};

const id_mk_agent_1_b2 = /** @type {(inputs: Mk_Agent_1_B2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkrip lengkap: alat apa yang dipakai, data apa yang dibaca`)
};

/**
* | output |
* | --- |
* | "A full transcript: which tools it used, which data it read" |
*
* @param {Mk_Agent_1_B2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_1_b2 = /** @type {((inputs?: Mk_Agent_1_B2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_1_B2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_1_b2(inputs)
	return en_mk_agent_1_b2(inputs)
});